import { render, staticRenderFns } from "./BrokenAppointmentsSkeleton.vue?vue&type=template&id=3e986bd6&scoped=true"
import script from "./BrokenAppointmentsSkeleton.vue?vue&type=script&lang=js"
export * from "./BrokenAppointmentsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BrokenAppointmentsSkeleton.vue?vue&type=style&index=0&id=3e986bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e986bd6",
  null
  
)

export default component.exports